import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createCallStatusReportSlice = (set, get) => ({
    crmCallStatusReport: {
        loading: false,
        data: [],
    },
    getCrmCallStatusReport: async () => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ crmCallStatusReport: { ...state.crmCallStatusReport, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: '/v1/crm/call-status',
                headers: { token }
            });
            set(state => ({ crmCallStatusReport: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ crmCallStatusReport: { ...state.crmCallStatusReport, loading: false } }));
        }
    }
});
